<p-dialog
  [header]="title"
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [blockScroll]="false"
  [responsive]="true"
  [closable]="false"
  appendTo="body"
  (onShow)="this.visibleChange.emit(true)"
  (onHide)="this.visibleChange.emit(false)"
  data-cy="confirmation-modal"
>
  <div class="mb-6" data-cy="confirmation-content" (keydown.esc)="handleCancel()">{{ message }}</div>
  <app-form-footer
    [submitLabel]="submitLabel"
    [cancelLabel]="cancelLabel"
    [handleCancel]="handleCancel.bind(this)"
    [handleSubmit]="handleSubmit.bind(this)"
    [disabled]="disabled"
    [noCancel]="noCancel"
    [appAutoFocus]="visible"
    (keydown.esc)="handleCancel()"
  ></app-form-footer>
</p-dialog>
